import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalService {

  modalParams$: BehaviorSubject<IConfirmationModalParams> = new BehaviorSubject(null);

  constructor() { }

  openModal(modalParams: IConfirmationModalParams): void {
    this.modalParams$.next(modalParams);
  }

  closeModal(): void {
    this.modalParams$.next(null);
  }
}

export interface IConfirmationModalParams {
  title: string;
  buttons: IConfirmationModalButton[];
  hideControls?: boolean;
}

export interface IConfirmationModalButton {
  text: string;
  method: () => Promise<void>;
}